import { Fragment } from 'react'

import { Link } from 'react-router'

import type { BlogAuthor } from '@/models/blog.server'

type Props = {
  authors: BlogAuthor[]
}

export default function BlogAuthors({ authors }: Props) {
  return (
    <>
      {authors.map((author, i) => (
        <Fragment key={author.slug}>
          {i > 0 && ', '}
          <Link className='text-contrast no-underline' prefetch='intent' to={`/blog/author/${author.slug}`}>
            {author.name}
          </Link>
          {author.x && (
            <>
              {' '}
              [
              <a
                className='no-underline hover:bg-blue-100 dark:hover:bg-blue-900'
                href={`https://x.com/${author.x}`}
                rel='noopener noreferrer'
                target='_blank'
                title={`@${author.x} on X`}
              >
                @{author.x}
              </a>
              ]
            </>
          )}
        </Fragment>
      ))}
    </>
  )
}
